import * as React from 'react'
import * as S from './NumberBadge.styles'

/**
 * Adds a small badge to an element, positioned relatively to its parent.
 * @example
 * ```tsx
 * <div style={{ position: 'relative' }}>
 *   <CartButton />
 *   <NumberBadge text="3" />
 * </div>
 * ```
 */

const NumberBadge: React.FC<Props> = ({ text, children = undefined }) => {
  if (!text) return null
  return (
    <S.NumberBadge data-testid="number-badge">{text || children}</S.NumberBadge>
  )
}

interface Props {
  text?: string
  children?: React.ReactNode
}

export default NumberBadge
